import { SxProps } from '@mui/material';
import { lightTheme } from '../../theme/index';

const { palette, spacing } = lightTheme;

const styles: Record<string, SxProps> = {
  cardMainBox: {
    width: '100%',
    borderRadius: '0.25rem',
    backgroundColor: palette.grey['50'],
    boxShadow: '0px 3.8548px 15.41922px 0px rgba(151, 151, 151, 0.16)',
    height: '100%',
    padding: spacing(0.5),
    '&:hover': {
      backgroundColor: palette.lightishAqua.main
    },

    a: {
      textDecoration: 'none'
    },
    '.cardParent': {
      height: '100%',
      display: 'flex',
      flexDirection: 'column'
    }
  },

  mainImgBox: {
    minHeight: '12rem',

    img: {
      borderRadius: '0.25rem'
    }
  },

  textBox: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    flexGrow: 2,
    '> *:last-child': {
      marginBottom: 0
    }
  },
  title: {
    color: palette.grey.main,
    mb: 'auto'
  },

  price: {
    color: palette.primary.main,
    mt: spacing(0.5)
  },

  description: {
    color: palette.grey['400'],
    mt: spacing(0.5)
  }
};

export default styles;
